<template>
  <div class="group-subs-section">
    <p @click.prevent="toggleSubConfigs" class="add-config-dropdown">
      <b>{{addConfigDropdown ? '-' : '+'}} add sub filters</b>
    </p>
    <div v-if="addConfigDropdown"
         class="group-sub-date-picker">
      <label :class="['data-description']"
             class="date-range">select date range</label>
      <loading-icon v-if="isLoadingSub"
                    loadingIconClasses="group-subs-loading"></loading-icon>
      <div v-else class="sub-config-picker-wrapper">
        <flat-pickr v-model="dateRange"
                    ref="dateRange"
                    class="date-range-picker"
                    :config="config"
                    mode="range"
                    name="sendDateRange"
                    placeholder="Select date range"></flat-pickr>
        <small v-if="dateRange"
               class="clear-dates"
               title="Clear"
               @click="clearDates"
               data-clear>clear</small>
      </div>
    </div>
  </div>
</template>

<script>
  import flatPickr from 'vue-flatpickr-component'
  import LoadingIcon from '../shared/LoadingIcon'

  export default {
    props: {
      selectedDateRange: String,
      isLoadingSub: Boolean,
    },

    name: 'SubConfigDatePicker',

    components: {
      flatPickr,
      LoadingIcon
    },

    data() {
      return {
        addConfigDropdown: false,
        config: {
          dateFormat: 'Y-m-d',
          maxDate: "today",
          mode: 'range',
          onChange: this.updateSelectedDate,
          onReady: this.initFlatpickr,
          wrap: true
        },
        dateRange: null,
        firstOpen: false,
      };
    },

    methods: {
      clearDates(event) {
        event.stopPropagation()
        this.dateRange = null
        this.$emit('clearSelectedDates')
      },

      initFlatpickr(p1, p2, fp) {
        fp.calendarContainer.classList.add('group-picker')
      },

      toggleSubConfigs(event) {
        event.stopPropagation()
        this.addConfigDropdown = !this.addConfigDropdown
      },

      updateSelectedDate(selectedDates, dateStr) {
        if (!selectedDates || selectedDates.length !== 1) {
          let selectedDateRange = this.selectedDateRange ? this.selectedDateRange : this.dateRange
          if (dateStr !== selectedDateRange) {
            this.dateRange = dateStr
            this.$emit('updateSelectedDate', dateStr)
          }
        }
      },
    },

    created() {
      if (this.selectedDateRange) {
        this.dateRange = this.selectedDateRange
        this.addConfigDropdown = true
      }
    },

    watch: {
      selectedDateRange: function () {
        if (this.selectedDateRange && this.selectedDateRange !== this.dateRange) {
          this.dateRange = this.selectedDateRange
          this.addConfigDropdown = true
        }
      },
    },
  }
</script>